import React, { useCallback, useEffect } from "react";
import { useClientPortalMetadataStore } from "../../../../Store/ClientPortalMetadata";

export interface ClientPortalBrandingNameLogoProps {
  className?: string;
}

const ClientPortalBrandingNameLogo: React.FC<ClientPortalBrandingNameLogoProps> = ({
  className
}) => {
  const { partnerWhiteLabelMetadata, getClientPortalMetadata, clientPortalUUID } =
    useClientPortalMetadataStore();

  const refreshThings = useCallback(async () => {
    if (clientPortalUUID) {
      await getClientPortalMetadata(clientPortalUUID);
    }
  }, [clientPortalUUID, getClientPortalMetadata]);

  useEffect(() => {
    refreshThings();
  }, [refreshThings, clientPortalUUID]);

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {partnerWhiteLabelMetadata?.branding_company_logo_s3_url &&
        partnerWhiteLabelMetadata.branding_company_logo_s3_url.length > 0 && (
          <img
            src={partnerWhiteLabelMetadata.branding_company_logo_s3_url}
            alt="Company Logo"
            className="max-h-10"
          />
        )}
      <span className="font-semibold">{partnerWhiteLabelMetadata?.name}</span>
    </div>
  );
};

export default ClientPortalBrandingNameLogo;
